/**
 * Created by swandelow on 8/24/16.
 */
angular.module('CarsSaraBo').factory('SpecialOfferService', [
  '$resource',
  'DateService', 
  function ($resource, dateService) {
    return {
        resource: $resource('../rest/company/:companyOid/specialoffer/:oid',
            {companyOid: '@companyOid', oid: '@oid'},
            {
                post: {method: 'POST'},
                delete: {method: 'DELETE'},
                get: {method: 'GET'},
                getOne: {method: 'GET'},
                moderate: {method: 'PATCH'}
            }),

        resourceFilter: $resource('../rest/specialoffer'),

        resourceEmailClick: $resource('../rest/specialoffer/:specialOfferOID/emailclick',
            {specialOfferOID: '@specialOfferOID'},
            {
                clickMailButton: {method: 'GET'}
            }),

        clickMailButton: function (specialOfferOid) {
            return this.resourceEmailClick.clickMailButton({specialOfferOID: specialOfferOid}).$promise;
        },


        fetchByCompany: function (companyOid, filters, page, offset) {
            var params = {companyOid: companyOid, pageNumber: page, itemsPerPage: offset};
            angular.extend(params, filters);
            return this.resource.get(params).$promise;
        },

        fetch: function (companyOid, specialOfferOid) {
            return this.resource.getOne({companyOid: companyOid, oid: specialOfferOid}).$promise;
        },

        save: function (companyOid, specialOffer) {
            // prepare request body
            var requestBody = angular.copy(specialOffer);
            requestBody.companyOid = companyOid;
            requestBody.bookingWindow = this.translatePeriod(specialOffer.bookingWindow);
            requestBody.validityPeriod = this.translatePeriod(specialOffer.validityPeriod);
            return this.resource.post({companyOid: companyOid}, requestBody).$promise;
        },

        translatePeriod: function (period) {
            // for periods that are not required.
            if (period == undefined) {
                return period;
            }
            var translatedPeriod = {};
            translatedPeriod.from = dateService.customFormatDate(period.from, "yyyyMMdd");
            translatedPeriod.to = dateService.customFormatDate(period.to, "yyyyMMdd");
            return translatedPeriod;
        },

        remove: function (specialOffer) {
            return this.resource.delete({companyOid: specialOffer.companyOid, oid: specialOffer.oid}).$promise;
        },

        moderate: function (companyId, specialOfferId, status) {
            var moderation = {};
            return this.resource.moderate({companyOid: companyId, oid: specialOfferId}, {status: status}).$promise;
        },

        fetchByFilter: function (filter, page, offset) {
            var params = {pageNumber: page, itemsPerPage: offset};
            angular.extend(params, filter);
            return this.resourceFilter.get(params).$promise;
        }
    }
}]);




//////////////////
// WEBPACK FOOTER
// ./public/app/models/special_offer_service.js
// module id = 867
// module chunks = 3